import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

export default function useDebouncedValue<T>(value: T) {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		const debouncedFn = debounce(() => {
			setDebouncedValue(value);
		}, 500);

		debouncedFn();

		return () => {
			debouncedFn.cancel();
		};
	}, [value]);

	return debouncedValue;
}
